import React from 'react'
import { Menu, MenuItem, MenuItemHeader } from '../../../shared/menu/menu'
import { IconCsv, IconExport } from '../../../shared/icon/icon'
import { useDownload } from '../../../shared/download/hook'
import { exportEndpoint } from './lms-insight-query'

// The formats the analytics exports come in (the audit log's, by the same
// names): csv and ndjson, called "CSV" and "JSON lines".
export const EXPORT_FORMATS = [
  { id: 'csv', label: 'CSV', Icon: IconCsv },
  { id: 'ndjson', label: 'JSON lines', Icon: IconExport }
]

// The page's downloads: every report a tab offers, in each format, asked for
// with the filters now chosen (tz included). exports is the tab's
// [{ report, label }]; the download goes through useDownload (the signed-in
// session rides along as ?auth=).
export const ExportMenu = ({ exports, filters }) => {
  const { active, download } = useDownload()

  if (!exports || !exports.length) return null

  return (
    <Menu sentenceCase>
      <MenuItemHeader text="Export" show />
      {exports.flatMap(report => [
        <MenuItemHeader key={`${report.report}-heading`} text={report.label} show />,
        ...EXPORT_FORMATS.map(format =>
          <MenuItem
            key={`${report.report}-${format.id}`}
            Icon={format.Icon}
            text={format.label}
            title={`${report.label} as ${format.label}`}
            disabled={active}
            onClick={() => download(process.env.REACT_APP_API_ANALYTICS, exportEndpoint(report.report, filters, format.id))}
            show
          />
        )
      ])}
    </Menu>
  )
}
